import React, { useEffect, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Aggrid from "../../framework/AgGrid";
import { fetchHealthStatus } from "../../services/branch-service";
import classes from "./index.module.css";
import Button from "../../framework/Button";
const getBGColor = (status) => {
  switch (status) {
    case "green":
      return "green";
    case "yellow":
      return "orange";
    case "red":
      return "red";
    default:
      return "transparent";
  }
};
const healthColumnDefs = [
  {
    headerName: "Server Name",
    field: "sym_engine",
  },
  {
    headerName: "Sym URL",
    field: "sym_url",
  },
  {
    headerName: "Last Heartbeat",
    field: "lastHeartbeat",
  },
  {
    headerName: "Server Status",
    field: "status",
    cellRendererFramework: (params) => {
      const getBGColor = (status) => {
        switch (status) {
          case "green":
            return "green";
          case "yellow":
            return "orange";
          case "red":
            return "red";
          default:
            return "transparent";
        }
      };
      return (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <div
            style={{
              fontWeight: 700,
              color: "#fff",
              background: getBGColor(params?.value?.toLowerCase()),
              borderRadius: "10px",
              padding: "10px 20px",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {params.data.status}
          </div>
        </div>
      );
    },
  },
];
const terminalColumnDefs = [
  {
    headerName: "Terminal Name",
    field: "sym_engine",
  },
  {
    headerName: "Terminal URL",
    field: "sym_url",
  },
  {
    headerName: "Terminal Status",
    field: "status",
    cellRendererFramework: (params) => {
      return (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <div
            style={{
              fontWeight: 700,
              color: "#fff",
              background: getBGColor(params?.value?.toLowerCase()),
              borderRadius: "10px",
              padding: "10px 20px",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {params.data.status}
          </div>
        </div>
      );
    },
  },
];
const HealthStatus = () => {
  const [data, setData] = useState([]);
  const [code, setCode] = useState();
  const refreshHealth = () => {
    fetchHealthStatus().then((r) => {
      if (r.result?.length > 0) {
        setData(r.result);
        setCode(r.result[r.result.length - 1]?.code);
      }
    });
  };
  useEffect(() => {
    refreshHealth();
  }, []);
  return (
    <div className={classes["health-status"]}>
      {data?.map((d, index) => {
        return (
          <React.Fragment key={`health-status-${index}`}>
            <Accordion
              expanded={code === d.code}
              onChange={(e) => setCode(d.code)}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "#000" }} />}
                sx={{
                  background: getBGColor(
                    d.health_stats?.sym?.server_status.toLowerCase()
                  ),
                }}
              >
                <div className={classes["summary"]}>
                  <div className={classes["header"]}>{`${d.code} : ${d.name} ${
                    d.region ? "(" + d.region + ")" : ""
                  }`}</div>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div
                  style={{
                    width: "100%",
                    height: "300px",
                    display: "flex",
                    padding: "5px",
                    gap: "10px",
                  }}
                >
                  <div
                    style={{
                      width: "70%",
                      height: "100%",
                      borderRadius: "10px",
                      boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                      display: "flex",
                      flexDirection: "column",
                      padding: "10px",
                      gap: "10px",
                    }}
                  >
                    <div className={classes["header"]}>Servers</div>
                    <Aggrid
                      rowData={d.health_stats?.sym?.servers || []}
                      columnDefs={healthColumnDefs}
                      onGridReady={(params) => params.api?.sizeColumnsToFit()}
                    />
                  </div>
                  <div
                    style={{
                      width: "30%",
                      height: "100%",
                      borderRadius: "10px",
                      boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                      display: "flex",
                      flexDirection: "column",
                      padding: "10px",
                      gap: "10px",
                    }}
                  >
                    <div className={classes["header"]}>Terminals</div>
                    <Aggrid
                      rowData={d.health_stats?.sym?.terminals || []}
                      columnDefs={terminalColumnDefs}
                      onGridReady={(params) => params.api?.sizeColumnsToFit()}
                    />
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </React.Fragment>
        );
      })}
      <div className={classes["health-status-refresh"]}>
        <Button label="Refresh" color="violet" onClick={refreshHealth} />
      </div>
    </div>
  );
};

export default HealthStatus;
